import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { SurveyComponent } from '../../../../models/SurveyTemplates';
import { Namespace } from '../../../../locales/translations';

interface DatePickerFieldProps {
    field: SurveyComponent;
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
    field,
    value = '',
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.FORMS]);//TODO: change to Namespace.SURVEY_BUILDER

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.value);
    };

    // Get min and max dates from field properties
    const minDate = field.properties?.minDate 
        ? moment(field.properties.minDate.seconds * 1000).format('YYYY-MM-DD')
        : undefined;
    const maxDate = field.properties?.maxDate 
        ? moment(field.properties.maxDate.seconds * 1000).format('YYYY-MM-DD')
        : undefined;

    const getHelperText = () => {
        if (field.properties?.minDate && field.properties?.maxDate) {
            return t('field_messages.date_picker.select_between', { minDate, maxDate });
        } else if (field.properties?.minDate) {
            return t('field_messages.date_picker.select_after', { minDate });
        } else if (field.properties?.maxDate) {
            return t('field_messages.date_picker.select_before', { maxDate });
        }
        return undefined;
    };

    return (
        <TextField
            type="date"
            value={value}
            onChange={handleChange}
            disabled={disabled}
            fullWidth
            variant="outlined"
            size="small"
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{
                min: minDate,
                max: maxDate,
            }}
            placeholder={field.placeholder}
            helperText={getHelperText()}
        />
    );
};

export default DatePickerField;
